import { ReactElement, ReactNode } from 'react';
import { CatTabs } from '@blocks-react/components/Tabs';
import { BlocksTabChange } from '@blocks-web-components/events/blocks-tab-change';

interface MyEquipmentTabsProps {
  children: ReactElement | string | ReactNode;
  activeIndex: number;
  onBlTabChange: (e: BlocksTabChange) => void;
  behavior?: 'full-width' | 'responsive-full-width';
}

export const MyEquipmentTabs = ({
  children,
  activeIndex,
  onBlTabChange,
  behavior = 'full-width',
}: MyEquipmentTabsProps) => {
  return (
    <CatTabs
      variant="contrast"
      behavior={behavior}
      activeIndex={activeIndex}
      onBlTabChange={onBlTabChange}
    >
      {children}
    </CatTabs>
  );
};
